import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=08a38738&scoped=true"
import script from "./UserManual.vue?vue&type=script&lang=js"
export * from "./UserManual.vue?vue&type=script&lang=js"
import style0 from "./UserManual.vue?vue&type=style&index=0&id=08a38738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a38738",
  null
  
)

export default component.exports